<template>
    <Modal @close="$emit('close')" :title="title">
        <NovakidPrivacyContent v-if="type == 'privacy'" />
        <NovakidTermsContent v-if="type == 'terms'" />
    </Modal>
</template>
<script>
import Modal from '@/components/Modal.vue'
import NovakidPrivacyContent from './NovakidPrivacyContent.vue'
import NovakidTermsContent from './NovakidTermsContent.vue'
export default {
    props: { type: String },
    components: { Modal, NovakidPrivacyContent, NovakidTermsContent },
    computed: {
        title() {
            return this.type == 'privacy' ? 'PRIVACY_NOVAKID' : 'TERMS_NOVAKID'
        }
    }
}
</script>
